import React from 'react';

import { ThemeProvider, useTheme } from '../../../v2/app/theme';
import LoginForm from './LoginForm';

const initial = (process.env.REACT_APP_MERCHANT || 'K').trim()[0].toUpperCase();

export default function LoginBox({ onSubmit }) {
    return (
        <ThemeProvider>
            <LoginBoxInner onSubmit={onSubmit} />
        </ThemeProvider>
    );
}

function LoginBoxInner({ onSubmit }) {
    const { theme } = useTheme();

    return (
        <div className={theme === 'dark' ? 'dark' : ''}>
            <div className="v2-root min-h-screen w-full flex items-center justify-center p-4 bg-gradient-to-br from-indigo-50 via-white to-cyan-50 dark:from-gray-950 dark:via-gray-900 dark:to-gray-950">
                <div className="w-full max-w-md rounded-2xl border border-solid border-gray-200 bg-white p-8 shadow-xl dark:border-gray-800 dark:bg-gray-900">
                    <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-indigo-500 to-cyan-500 text-2xl font-semibold text-white shadow-lg shadow-indigo-500/30">
                        {initial}
                    </div>
                    <h1 className="text-2xl font-semibold tracking-tight text-gray-900 dark:text-gray-50">
                        Bun venit
                    </h1>
                    <p className="mt-1.5 mb-7 text-sm text-gray-500 dark:text-gray-400">
                        Introdu datele de acces pentru a continua.
                    </p>
                    <LoginForm onSubmit={onSubmit} />
                </div>
            </div>
        </div>
    );
}
